<template>
  <div>
    <div class="d-flex align-items-center">
      <span class="dot text-center pl-1">
        <i class="fas fa-calendar-alt" />
      </span>
      <span class="color-gray-7 bold font-16">
        Coordinar Cita
      </span>
    </div>
    <validation-observer ref="insertSpaceRef" novalidate tag="form">
      <div class="row mt-3 ml-0">
        <div class="col-md-3 col-sm-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.company"
              :options="catalog.companies"
              label="Compañía:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              required
              :error="errors[0]"
              custom-error-msg="La compañía es requerida."
              @input="onChangeCompany"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.locationService"
              :options="catalog.serviceLocations"
              label="Lugar de Servicio:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :error="errors[0]"
              custom-error-msg="El lugar de servicio es requerido."
              @input="onChangeServiceLocation"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-3 col-sm-12 mt-3 mt-md-0">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.specialist"
              :options="catalog.specialists"
              label="Especialista:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              :error="errors[0]"
              custom-error-msg="El especialista es requerido."
            />
          </ValidationProvider>
        </div>
        <div class="col-md-3 col-sm-12">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.center"
              :options="catalog.centers"
              label="Centro:"
              fieldkey="id"
              fieldname="name"
              placeholder="Seleccione"
              required
              :error="errors[0]"
              custom-error-msg="El centro es requerido."
            />
          </ValidationProvider>
        </div>
        <div class="col-md-3 col-sm-12 mt-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-date-picker
              v-model="model.date"
              label="Fecha:"
              placeholder="DD/MM/YYYY"
              :min-date="minStartDate"
              :error="errors[0]"
              custom-error-msg="La fecha es requerida."
            />
          </ValidationProvider>
        </div>
        <div class="col-md-3 col-sm-12 mt-3">
          <div>
            <div class="color-secondary-6 font-weight-normal font-14">
              Hora Desde:
            </div>
            <div class="d-flex align-items-center mt-2">
              <ValidationProvider v-slot="{}" rules="required">
                <custom-input
                  v-model="model.startDateHour"
                  class="hour-size"
                  mask-type="Day"
                  type="text"
                  @input="evalEnterHour"
                />
              </ValidationProvider>
              <span class="mr-3 mt-1">:</span>
              <ValidationProvider v-slot="{}" rules="required">
                <custom-input
                  v-model="model.startDateMinute"
                  class="hour-size"
                  mask-type="Day"
                  type="text"
                  @input="evalEnterMinute"
                />
              </ValidationProvider>
              <ValidationProvider v-slot="{}" rules="required">
                <b-form-select
                  v-model="model.startDateAmPm"
                  class="ampm-size"
                  :options="timeOptions"
                  required
                  @input="evalEnterAmPm"
                />
              </ValidationProvider>

              <span
                v-if="model.endDateHour !== null"
                class="color-gray-6 mr-3 mt-1"
              >
                / {{ model.endDateHour }} : {{ model.endDateMinute }}
                {{ model.endDateAmPm }}
              </span>
            </div>
            <error
              v-if="dateValidation"
              :message="dateValidation"
              variant="no-border"
            />
          </div>
        </div>
        <div class="col-md-3 col-sm-12 mt-3">
          <ValidationProvider v-slot="{ errors }" rules="required">
            <custom-drop-down
              v-model="model.duration"
              :options="catalog.durations"
              label="Duración:"
              fieldkey="value"
              fieldname="text"
              placeholder="Seleccione"
              :error="errors[0]"
              custom-error-msg="La duración es requerida."
              @input="onDurationChange"
            />
          </ValidationProvider>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end">
          <action-button
            id="modal-btn-cancelar"
            variant="outline-danger mr-2"
            i="fas fa-times-circle"
            text="Cancelar"
            @click="$emit('on-cancel')"
          />
          <action-button
            i="fas fa-save"
            variant="success"
            text="Guardar"
            @click="handlerSave()"
          />
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';
import { Error } from '@/components/common';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import moment from 'moment';
import 'moment/locale/es-do';
import Service from '@/modules/referral/api';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import alertMixin from '@/mixin/alert.mixin';
import appointmentServices from '@/services/api/appointment.api.js';

export default {
  name: 'CoordinateAppointment',
  components: {
    CustomDropDown,
    CustomDatePicker,
    ActionButton,
    CustomInput,
    ValidationProvider,
    ValidationObserver,
    Error,
  },
  mixins: [alertMixin],
  props: {
    disciplineTypeId: {
      type: Number,
      required: true,
      default: 0,
    },
    studentSieId: {
      type: Number,
      required: true,
      default: 0,
    },
    studentReferralId: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  data() {
    return {
      dateValidation: null,
      model: {
        company: null,
        municipality: null,
        locationService: null,
        specialist: null,
        center: null,
        date: null,
        startDateHour: null,
        startDateMinute: null,
        startDateAmPm: null,
        duration: null,
        endDateHour: null,
        endDateMinute: null,
        endDateAmPm: null,
      },
      catalog: {
        companies: [],
        municipalities: [],
        serviceLocations: [],
        specialists: [],
        centers: [],
        durations: [
          { value: '30', text: '30 min' },
          { value: '45', text: '45 min' },
          { value: '60', text: '60 min' },
        ],
      },
    };
  },
  computed: {
    timeOptions() {
      return [
        { value: 'am', text: 'AM' },
        { value: 'pm', text: 'PM' },
      ];
    },
    minStartDate() {
      return moment()
        .add('days', -1)
        .toDate();
    },
  },
  async mounted() {
    await this.getCompaniesList();
    await this.getCentersList();
  },
  methods: {
    async getCentersList() {
      const { data } = await appointmentServices.getCenters();
      this.catalog.centers = data;
    },
    async getCompaniesList() {
      const { data } = await appointmentServices.getCompanies(
        this.disciplineTypeId
      );
      this.catalog.companies = data;
    },
    async getServiceLocationsList() {
      if (!this.model.company) return;

      const {
        data,
      } = await appointmentServices.getLocationServicesForSpecialists(
        this.currentAcademicYear().id,
        this.model.company.id,
        this.disciplineTypeId
      );
      this.catalog.serviceLocations = data;
    },
    async getSpecialistList() {
      const data = await Service.getSpecialists(
        this.currentAcademicYear().id,
        null,
        null,
        this.model.locationService.municipalityId,
        null,
        this.model.locationService.id,
        this.disciplineTypeId
      );
      this.catalog.specialists = data;
    },
    async onChangeCompany(value) {
      if (value) {
        this.model.locationService = null;
        this.model.specialist = null;
        await this.getServiceLocationsList();
      }
    },
    onChangeServiceLocation(value) {
      this.model.specialist = null;
      if (!value) return;

      this.getSpecialistList();
    },
    onDurationChange() {
      this.setEndHour();
    },
    setEndHour() {
      if (!this.isHourValid()) {
        this.model.endDateHour = '';
        return;
      }

      const hour = this.eval24Hour(
        this.model.startDateAmPm,
        parseInt(this.model.startDateHour)
      );
      const minute = parseInt(this.model.startDateMinute) || 0;

      const endDate = moment(new Date()).set({
        hour: hour,
        minute: minute + parseInt(this.model.duration.value),
      });
      const amOrPmText = endDate.format('h:mm a').split(' ')[1];

      this.model.endDateHour = this.get12HoursFormat(
        amOrPmText,
        endDate.hour()
      );

      this.model.endDateMinute =
        endDate.minute().toString().length == 1 ? '00' : endDate.minute();
      this.model.endDateAmPm = amOrPmText;
    },
    evalEnterHour() {
      if (this.model.startDateHour) {
        const valueHour = parseInt(this.model.startDateHour);
        const ampmResult = this.getAmPm(valueHour);

        this.model.ampmDisabled = ampmResult.disabled;
        this.model.startDateAmPm = ampmResult.time;

        this.evalEndHour();
      }
    },
    evalEndHour() {
      if (
        this.model.startDateHour &&
        this.model.startDateMinute &&
        this.model.startDateAmPm
      ) {
        const isHourValid = this.isHourValid();
        if (isHourValid) {
          this.setEndHour();
        } else {
          this.model.endDateHour = '';
        }
      }
    },
    isHourValid() {
      if (
        this.model.startDateHour &&
        this.model.startDateMinute &&
        this.model.startDateAmPm
      ) {
        let minutes = this.model.startDateMinute;
        if (minutes === '00') minutes = '0';

        const _isValid = moment(
          `${this.model.startDateHour}:${minutes} ${this.model.startDateAmPm}`,
          'h:m A',
          true
        ).isValid();
        return _isValid;
      }
    },
    evalEnterMinute() {
      this.evalEndHour();
    },
    evalEnterAmPm() {
      this.evalEndHour();
    },
    eval24Hour(ampm, hour) {
      let output = hour;
      if (ampm == 'pm') {
        if (hour != 12) {
          output = hour + 12;
        }
      } else if (ampm == 'am') {
        if (hour == 12) {
          output = 0;
        }
      }
      return output;
    },
    getAmPm(valueHour) {
      let result = { time: 'am', disabled: true };
      if (valueHour == 12 || (valueHour >= 1 && valueHour <= 5)) {
        result.time = 'pm';
      } else if (valueHour >= 8 && valueHour <= 11) {
        result.time = 'am';
      } else {
        result.disabled = false;
      }
      return result;
    },
    get12HoursFormat(ampm, hour) {
      let output = hour;
      if (ampm == 'pm' && hour > 12) output = hour - 12;

      return output;
    },
    async handlerSave() {
      const isValid = await this.$refs.insertSpaceRef.validate();

      //validate date
      const _hasValidDate = this.isHourValid();
      this.dateValidation = !_hasValidDate ? 'La fecha no es válida' : null;

      if (!isValid || !_hasValidDate) {
        this.ShowToast('Alerta', 'Información Incompleta', 'error');
        return;
      }
      await appointmentServices
        .saveAppointmentCoordinate({
          appointmentToCoordinate: {
            studentReferralId: this.studentReferralId,
            studentSieId: this.studentSieId,
            coordinatedByCenterId: this.model.center.id,
            startDate: moment(
              `${moment(this.model.date).format('MM/DD/yyyy')} ${
                this.model.startDateAmPm === 'am'
                  ? this.model.startDateHour
                  : parseInt(this.model.startDateHour) + 12
              }:${this.model.startDateMinute}:00`
            ),
            duration: parseInt(this.model.duration.value),
            locationServiceId: this.model.locationService.id,
            disciplineTypeId: this.disciplineTypeId,
            specialistId: this.model.specialist.id,
          },
        })
        .then(async (appointment) => {
          this.ShowToast(
            'Notificación',
            'La cita ha sido coordinada exitosamente.',
            'success'
          );
          this.$emit('on-save', appointment.data);
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
@use "sass:map";
@import '@/assets/scss/variables/_colors.scss';

.dot {
  width: 24px;
  height: 24px;
  color: map.get($colors, 'orange');
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: map.get($colors, 'white') 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px map.get($colors, 'gray-11');
  padding-top: 1px;
  padding-right: 4px;
  margin-right: 5px;
}
.hour-size {
  width: 60px;
  margin-right: 10px;
}
.ampm-size {
  width: 80px;
  margin-right: 10px;
}
</style>
